export class HisInformationUpdateEveryTimeMaster {
  private static master: string[] = [
    "LAST_UPDATE_USER",
    "USER_ACCOUNT",
    "LAST_UPDATE_DATE",
    "HOST_NAME",
    // "RECONGNIZE_USER", // バックエンドで反映
  ];

  static isUpdateEveryTime(key: string): boolean {
    return this.master.indexOf(key) >= 0;
  }
}
